import styled from 'styled-components';

export const MainContent = styled.main`
  padding-top: ${({ isNavMenuVisible }) => (isNavMenuVisible ? '80px' : '0')};
`;
